exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slide-types__header{margin:0 12px;padding:6px 0;line-height:20px;color:#939598;font-size:14px;font-family:GTWalsheimProBold;letter-spacing:0}.slide-types span:first-of-type{border-top:1px solid #939598}.slide-types span:first-of-type:hover{border-top-color:transparent}.slide-types__option{display:block;padding:6px 12px;cursor:pointer;line-height:20px;color:#939598;font-size:12px;letter-spacing:0}.slide-types__option:hover{background-color:#3cb449;color:#fff}.slide-types__option:hover .summary_info:before{color:#fff}.slide-types__option .summary_info{margin-left:5px;vertical-align:middle;cursor:pointer;font-size:15px}.slide-types__option .summary_info:before{color:#939598}.slide-types__option .summary_info:hover{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader/src!./~/less-loader!./src/components/pages/livefeed/Editor/EditorContainer/SlidesContainer/SlideTypesAdd/slideTypes.less
// module id = 2262
// module chunks = 0